/**
 * Topes del chat público (DESIGN DD23, ADR-051, ADR-052). Valores de producto:
 * el entorno puede reajustar alguno en la composición, nunca aquí.
 */
export const PUBLIC_CHAT_LIMITS = {
  /** Mensajes del niño por sesión. */
  sessionMessages: 5,
  /** Mensajes contestados por día UTC en todo el chat público (tope global). */
  globalDailyMessages: 2000,
  /** Sesiones nuevas por IP y día UTC. */
  ipSessionsPerDay: 3,
  /** Segundos mínimos entre dos mensajes de la misma sesión. */
  paceSeconds: 3,
  /** Caracteres del nombre saneado del niño. */
  maxNameLength: 40,
  /** Caracteres de un turno de Papá Noel al guardarlo en el token. */
  maxSantaTurnLength: 300,
  /** Bytes del token serializado: más grande ⇒ se rechaza antes de verificar la firma. */
  maxTokenBytes: 16 * 1024,
} as const
